import { useMemo } from "react";
import type { ReactNode } from "react";
import { ColumnReorderContext } from "./columnReorderContext";
import type { ColumnReorderApi } from "./columnReorderContext";

/** Gives the draggable header cells of a table access to `moveColumn` without prop drilling. */
export default function ColumnReorderProvider({
  moveColumn,
  children,
}: ColumnReorderApi & { children: ReactNode }) {
  const value = useMemo(() => ({ moveColumn }), [moveColumn]);
  return (
    <ColumnReorderContext.Provider value={value}>
      {children}
    </ColumnReorderContext.Provider>
  );
}
